import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { messageClear } from "../store/reducers/authReducer"; /*obtneerr la url de envio*/
import toast from "react-hot-toast";
import { FadeLoader } from "react-spinners";
import { Helmet } from "react-helmet";
const Nosotros = () => {
  const navigate = useNavigate();
  const { loader, errorMessage, successMessage} = useSelector(state => state.auth);
  const dispatch = useDispatch();
  /*cambiar el dispath*/
  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
    }
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }
 
  }, [successMessage, errorMessage,  dispatch, navigate]);

  return (
    <div>
      {loader && (
        <div className="w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-[#38303033] z-[999]">
          <FadeLoader />
        </div>
      )}

      <Header />
      <Helmet>
        <title>Nosotros | Tekos.pe</title>
        <meta name="description" content="Compra zapatillas Adidas al mejor precio en Tekos. Envíos a todo Perú." />
        <meta name="keywords" content="zapatillas, Adidas, ofertas, calzado deportivo" />
      </Helmet>
      <div className="bg-slate-200 mt-4">
        <div className="w-full justify-center items-center p-10">
          <div className="max-w-6xl mx-auto mx-auto bg-white rounded-md">
            <div className="px-8 py-8">
              <div className="mb-8">
                <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">¿QUIENES SOMOS?</h2>
                <p className="font-bold mb-4">TEKOS.PE SOMOS LA MEJOR OPCIÓN PARA TI LOS TUYOS EN EL MUNDO DEL CALZADO</p>
              </div>

              {/* Sección Comentarios */}
              <div className="mb-8">
                <h2 className="text-2xl font-bold mb-4">Comentarios</h2>
                <p className="mb-4">
                  Cuando los visitantes dejan comentarios en el sitio, recopilamos los datos que se muestran en el formulario de comentarios, y también la dirección IP del visitante y la cadena del
                  agente de usuario del navegador para ayudar a la detección de spam.
                </p>
              </div>

              {/* Sección Cookies */}
              <div className="mb-8">
                <h2 className="text-2xl font-bold mb-4">Cookies</h2>
                <p className="mb-4">
                  Si deja un comentario en nuestro sitio, puede optar por guardar su nombre, dirección de correo electrónico y sitio web en cookies. Estos son para su comodidad, para que no tenga que
                  volver a rellenar sus datos cuando deje otro comentario. Estas cookies tendrán una duración de un año.
                </p>
                <p className="mb-4">
                  Si visita nuestra página de inicio de sesión, estableceremos una cookie temporal para determinar si su navegador acepta cookies. Esta cookie no contiene datos personales y se
                  descarta cuando cierra su navegador.
                </p>
                <p className="mb-4">
                  Cuando inicie sesión, también configuraremos varias cookies para guardar su información de inicio de sesión y sus opciones de visualización de pantalla. Las cookies de inicio de
                  sesión duran dos días y las cookies de opciones de pantalla duran un año. Si selecciona «Recordarme», su inicio de sesión persistirá durante dos semanas. Si cierra sesión en su
                  cuenta, se eliminarán las cookies de inicio de sesión.
                </p>
                <p className="mb-4">
                  Si edita o publica un artículo, se guardará una cookie adicional en su navegador. Esta cookie no incluye datos personales y simplemente indica el ID de publicación del artículo que
                  acaba de editar. Caduca después de 1 día.
                </p>
              </div>

              {/* Espaciadores */}
              <div className="mb-4">
                <h2 className="text-2xl font-bold mb-4">&nbsp;</h2>
                <p className="text-justify leading-normal text-sm">&nbsp;</p>
                <p>&nbsp;</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Nosotros;
